<template>
  <div v-if="show" class="post-preview js-open-preview">
    <div class="post-preview__content">
      <app-post-preview-close-button @click.native="hide()" />
      <div class="post-preview__content-inner">
        <div class="post-preview__content-img">
          <img :src="imageurl" />
        </div>
        <div class="content-body">
          <div class="">
            <p class="content-body__text" v-text="text" />
            <div v-if="!!video_filename && !!video_url" class="content-body__video">
              <video :src="video_url" controls="controls" width="100%"></video>
            </div>
            <div class="content-body__buttons">
              <div v-if="!!pdf_file_url && !!pdf_file_filename" class="button">
                <a :href="pdf_file_url" target="_blank" rel="noopener noreferrer">
                  {{ pdf_file_filename }}
                  <i class="fa fa-file" aria-hidden="true"></i>
                </a>
              </div>
              <div v-if="!!button_external_url && !!button_external_title" class="button">
                <a :href="button_external_url" target="_blank" rel="noopener noreferrer">
                  {{ button_external_title }}
                  <i class="fa fa-external-link" aria-hidden="true"></i>
                </a>
              </div>
              <div v-if="!!button_reception_url && !!button_reception_title" class="button">
                <a
                  :href="button_reception_url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="reception"
                >
                  {{ button_reception_title }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus, action } from '@/utility/event-bus';

export default {
  props: {
    text: String,
    button_external_title: {
      type: String,
      default: '',
    },
    button_external_url: {
      type: String,
      default: '',
    },
    button_reception_title: {
      type: String,
      default: '',
    },
    button_reception_url: {
      type: String,
      default: '',
    },
    imageurl: String,
    command: String,
    pdf_file_filename: {
      type: String,
      default: '',
    },
    pdf_file_url: {
      type: String,
      default: '',
    },
    video_filename: {
      type: String,
      default: '',
    },
    video_url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: this.command == 'show',
    };
  },
  created() {
    eventBus.$on(action.SHOW_POST_PREVIEW, () => {
      this.show = true;
    });
  },
  methods: {
    hide() {
      this.show = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.content-body
  margin-top: 30px

  &__text
    font-size: 16px
    white-space: pre-wrap
    word-break: break-word

  &__video
    margin-bottom: 20px

  &__buttons
    display: flex
    flex-direction: column
    gap: 20px

  .button
    a
      text-align: center
      border-radius: 5px
      display: block
      font-size: 1.25rem
      text-decoration: none
      font-weight: 600
      line-height: 1
      padding: 20px
      position: relative
      background: #28C3CD
      color: #fff
      font-size: 16px
      i
        color: #fff
        position: absolute
        right: 20px
    .reception
      background: #ff736e
</style>
